<ng-container *transloco="let t; prefix: 'tasks.taskFilter'">
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title">{{ t("title") }}</span>

        <button
            mat-icon-button
            type="button"
            aria-label="Chiudi"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content" [formGroup]="filterForm">
        <div class="task-type-filter">
            <p class="title-medium">{{t("type")}}</p>
            <!-- TODO: Mettere in un array e usare @for e event.value-->
            <mat-chip-listbox multiple="true">
                @for (tipo of tipiTask; track tipo) {
                    <mat-chip-option
                        (selectionChange)="onTipoTaskSelect($event, tipo)"
                        [selected]="checkTipoTaskSelected(tipo)">
                        {{ tipo }}
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        </div>


        <div class="date-filter">
            <p class="title-medium">{{t("dateRange")}}</p>
            <div class="date-container">
                <div class="input-date">
                    <p class="body-small date-label">{{t("from")}}</p>
                    <mat-form-field class="date-input">
                        <!-- <mat-label>Data inizio</mat-label> -->
                        <input matInput 
                            [matDatepicker]="pickerInizio" 
                            [formControl]="filterForm.controls['dataInizio']"
                            [max]="filterForm.controls['dataFine'].value">

                        <mat-datepicker-toggle matIconSuffix [for]="pickerInizio"></mat-datepicker-toggle>
                        <mat-datepicker #pickerInizio></mat-datepicker>
                        <!-- TODO: L'hint dovrebbe cambiare in base alla locale -->
                        <mat-hint>dd/MM/yyyy</mat-hint>
                    </mat-form-field>
                </div>

                <div class="input-date">
                    <p class="body-small date-label">{{t("to")}}</p>
                    <!-- appearance="outline" -->
                    <mat-form-field class="date-input">
                        <!-- <mat-label>Data fine</mat-label> -->
                        <input matInput 
                            [matDatepicker]="pickerFine" 
                            [formControl]="filterForm.controls['dataFine']"
                            [min]="filterForm.controls['dataInizio'].value">

                        <mat-datepicker-toggle matIconSuffix [for]="pickerFine"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFine></mat-datepicker>
                        <!-- TODO: L'hint dovrebbe cambiare in base alla locale -->
                        <mat-hint>dd/MM/yyyy</mat-hint>
                    </mat-form-field>
                </div>



            </div>
        </div>

        <div class="priority-filter">
            <p class="title-medium">{{t("priority")}}</p>
                <!-- TODO: Mettere in un array e usare @for e event.value-->
                <mat-chip-listbox multiple="true">
                    <div class="priority-chips-container">
                        <mat-chip-option
                            class="chip low"
                            (selectionChange)="onPrioritySelect($event, 'Low')"
                            [selected]="checkPrioritySelected('Low')">
                            {{t("prFilter.low")}}
                        </mat-chip-option>
                        <mat-chip-option 
                            class="chip medium"
                            (selectionChange)="onPrioritySelect($event, 'Medium')"
                            [selected]="checkPrioritySelected('Medium')">
                            {{t("prFilter.medium")}}
                        </mat-chip-option>
                        <mat-chip-option
                            class="chip high"
                            (selectionChange)="onPrioritySelect($event, 'High')"
                            [selected]="checkPrioritySelected('High')">
                            {{t("prFilter.high")}}
                        </mat-chip-option>
                    </div>
                </mat-chip-listbox>

        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton (click)="onCancelFilter()">{{t("clear")}}</button>

        <button matButton="filled" (click)="onConfirmFilter()">{{t("apply")}}</button>
    </mat-dialog-actions>
</ng-container>
